
export enum BadgeKind {
    Count = "sb-badge-count",
    Dot = "sb-badge-dot"
}


export enum BadgeColor {
    Attention = "sb-badge-attention",
    OnBrand = "sb-badge-on-brand",
    Brand = "sb-badge-brand",
}